export interface ChatActivityTimestampRecord {
  createdAt: string
  updatedAt?: string
}

export const getChatLastActivityTimestamp = (chat: ChatActivityTimestampRecord): string => {
  return chat.updatedAt ?? chat.createdAt
}

export type SortableTimestampValue = string | { valueOf: () => number } | undefined

export function getTimestampSortValue(timestamp: SortableTimestampValue): number {
  if (!timestamp) return 0

  const time = typeof timestamp === 'string' ? new Date(timestamp).getTime() : timestamp.valueOf()
  return Number.isNaN(time) ? 0 : time
}
